/* eslint-disable react-hooks/exhaustive-deps */

import React,{  } from 'react';
// import {ScoreBoard} from '../index.ts'
// import { Road } from '../roads/road.ts';
import { tie_includes} from '../Utility.js';
import { useSelector,useDispatch } from 'react-redux';
import {isMobile} from 'react-device-detect';


function StatisticsBox() {
    const state=useSelector((state)=>state);
    const dispatch = useDispatch();

    function isTie(order) {
        if(tie_includes(order+1))
        {
            if(tie_includes(order+2))
            {
                return <div className='div-row'></div>;
            }
            else{
                return <div></div>
            } 
        }
        else
        {
            return ;
        }
    }
    function isTieNum(order) {
        if(tie_includes(order+1))
        {
            if(tie_includes(order+2))
            {
                return 2;
            }
            else{
                return ;
            } 
        }
        else
        {
            return ;
        }
    }

    function bigR(a,b) { //a 0~5 b 0~23
        if(state.bigRoad!==null)
        {
            let convert_b = b;
            if(38 < state.bigRoad_colcount)
            {
                convert_b = state.bigRoad_colcount - 38 + b;
            }
            let item = state.bigRoad.getItem(a,convert_b);
            if(item!==undefined)
            {
                if(item.gameResult===1)
                {
                    
                    if(item.pairResult===0)
                    {
                        return <>{isTie(item.order)}<span className="red">{isTieNum(item.order)}</span></>;
                    }
                    else if(item.pairResult===1)
                    {
                        return <>{isTie(item.order)}<span className="red">{isTieNum(item.order)}<em className="red"></em></span></>;
                        
                    }
                    else if(item.pairResult===2)
                    {
                        return <>{isTie(item.order)}<span className="red">{isTieNum(item.order)}<em className="blue"></em></span></>
                    }
                    else if(item.pairResult===3)
                    {
                        return  <>{isTie(item.order)}<span className="red">{isTieNum(item.order)}<em className="red"></em><em className="blue"></em></span></>
                    }
                }
                else if(item.gameResult===2)
                {
                    if(item.pairResult===0)
                    {
                        return <>{isTie(item.order)}<span className="blue">{isTieNum(item.order)}</span></>
                    }
                    else if(item.pairResult===1)
                    {
                        return <>{isTie(item.order)}<span className="blue">{isTieNum(item.order)}<em className="red"></em></span></>
                    }
                    else if(item.pairResult===2)
                    {
                        return <>{isTie(item.order)}<span className="blue">{isTieNum(item.order)}<em className="blue"></em></span></>
                    }
                    else if(item.pairResult===3)
                    {
                        return  <>{isTie(item.order)}<span className="blue">{isTieNum(item.order)}<em className="red"></em><em className="blue"></em></span></>
                    }
                }
            }
            else
            return '';
        }
        else
        {
            return '';
        }
        
    }

    return(
        <div className="statistics-box">
            <div className="statistics-table">
                <div className="this-table-1">
                    {Array.from({length:60}).map((_, index)=>(
                        <ul key={index}>
                            {Array.from({length:6}).map((_,LiIndex)=>(
                                <li key={LiIndex}>
                                    {bigR(LiIndex,index)}
                                </li>
                            ))}
                        </ul>
                    ))}
                </div>
            </div>
        </div>
    );
}


export default StatisticsBox;